import React, { useState, useEffect } from "react";
import { HeaderText, Button, ReturnOptionCard } from "../";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateExchangeSettingsDetails } from "../../redux/slices";
import { exchangeSettingsActionTypes } from "../../redux/utils";
import { useOrderContext } from "../../contexts";
import { useHardCode } from "../../hooks";

export const ReturnOptions = () => {
  const [option, setOption] = useState();
  const { setRecentOrderID, setVariantID, setProductID } = useOrderContext();
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [changeRoute, setChangeRoute] = useState("");
  const navigate = useNavigate();
  const [isRefund, setIsRefund] = useState(true);
  const [incentiveMsg, setIncentiveMsg] = useState(true);
  const dispatch = useDispatch();
  const productDetailsState = useSelector((state) => state.productDetails);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const exchange_with_items_upto = isPureFemale
    ? PURE_FEMALE_TRANSLATION.return_options.exchange_with_items_upto
    : storeConfigState?.themeConfig?.exchange_with_items;
  const higher_than_the_original_item = isPureFemale
    ? PURE_FEMALE_TRANSLATION.return_options.higher_than_the_original_item
    : storeConfigState?.themeConfig?.higher_than_the_original_item;
  const get_additional_store_credit_of = isPureFemale
    ? PURE_FEMALE_TRANSLATION.return_options.get_additional_store_credit_of
    : storeConfigState?.themeConfig?.additional_store_credit;

  const returnOptions = [
    {
      id: "1",
      option:
        storeConfigState?.themeConfig?.return_exchange_page_exchange_card_label,
      desc: [
        {
          id: "1",
          iconURL: "assets/svg/bullet.svg",
          info: `${
            productDetailsState.collectPriceDifferencePercent
              ? `${exchange_with_items_upto} ${productDetailsState.collectPriceDifferencePercentValue}% ${higher_than_the_original_item}`
              : `${get_additional_store_credit_of} ${productDetailsState.currency}${refundSettingsState.incentive.exchange_store_credits.refund_value}`
          }`,

          isShow:
            parseInt(
              refundSettingsState.incentive.exchange_store_credits.refund_value
            ) > 0
              ? true
              : false,
        },
      ],
      item_card_desc: storeConfigState?.themeConfig?.exchange_item_card_desc,
      isShow: productDetailsState.exchangeItem,
      isAllowed:
        exchangeSettingsState.finalExchange ||
        productDetailsState.isPolicyOverwritten,
      isRefund: true,
    },
    {
      id: "2",
      option: "Sell it to neighbour at discount",
      desc: [
        {
          id: "1",
          iconURL: "assets/svg/floppy-disk.svg",
          info: "Save 2 kg of CO2 emission",
          isShow: false,
        },
        {
          id: "2",
          iconURL: "assets/svg/cards2.svg",
          info: `Get ${productDetailsState.currency}5 as store credit`,
          isShow: false,
        },
        {
          id: "3",
          iconURL: "assets/svg/return.svg",
          info: "Get 3 days of return extension",
          isShow: false,
        },
      ],
      isShow: false,
      isAllowed: true,
      isRefund: true,
    },
    {
      id: "3",
      option:
        storeConfigState?.themeConfig?.return_exchange_page_return_card_label,
      desc: [
        {
          id: "1",
          iconURL: "",
          info: "",
          isShow: false,
        },
      ],
      item_card_desc: storeConfigState?.themeConfig?.return_item_card_desc,
      isShow: productDetailsState.getRefund,
      isAllowed:
        exchangeSettingsState.finalIncentive ||
        productDetailsState.isPolicyOverwritten,
      isRefund: isRefund,
    },
  ];

  useEffect(() => {
    if (option === "1") {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
          value: "/exchange",
        })
      );

      setChangeRoute("/exchange");
    } else if (option === "2") {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
          value: null,
        })
      );
      setChangeRoute("/neighbour");
    } else {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
          value: "/refund",
        })
      );

      if (!exchangeSettingsState.isImageUpload) {
        if (refundSettingsState.enableIncentive) {
          setChangeRoute("/refund");
        } else {
          setChangeRoute("/RefundOptions");
        }
      } else {
        setChangeRoute("/photo");
      }
    }
  }, [option]);

  const buttonHandler = () => {
    const RecentOrderID = productDetailsState.recentOrderID;
    const VariantID = selectedProductDetailsState.variantID;
    const productID = selectedProductDetailsState.productID;
    setRecentOrderID(RecentOrderID);
    setVariantID(VariantID);
    setProductID(productID);

    if (option === "1") {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_FORWARD,
          value: changeRoute,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_EXCHANGE_OTHER,
          value: false,
        })
      );

      navigate(changeRoute);
    }
    if (option === "3") {
      if (
        refundSettingsState?.incentive?.keep_item_store_credits ||
        refundSettingsState?.incentive?.keep_item_store_credits === 0
      ) {
        setIsRefund(true);
        navigate(changeRoute);

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_FORWARD,
            value: changeRoute,
          })
        );
      }
      if (refundSettingsState?.incentiveMessage) {
        setIsRefund(false);
        setIncentiveMsg(refundSettingsState?.incentiveMessage);
        setIsBtnDisabled(true);
      }
    }
  };
  /* Navigate to Previous Page */
  const backHandler = () => {
    window.history.back();
  };

  return (
    <div className="saara-item-container">
      <div className="saara-item-heading">
        <div>
          <Link to="" onClick={backHandler} className="backIcon">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
        </div>

        <HeaderText
          text={storeConfigState?.themeConfig?.return_exchange_page_title}
        />
      </div>
      <div className="return-option-main">
        {returnOptions.map(
          (item) =>
            item.isShow && (
              <>
                <ReturnOptionCard
                  keyID={item.id}
                  heading={item.option}
                  isShowCard={item.isShow}
                  itemDescription={item.desc}
                  itemIsAllowed={!item.isAllowed}
                  storeConfigState={storeConfigState}
                  itemIsRefund={item.isRefund}
                  incentiveMsg={incentiveMsg}
                  extraDescription={item.item_card_desc}
                  isChecked={
                    option === item.id &&
                    item.isAllowed !== false &&
                    item.isRefund
                  }
                  onClick={() => {
                    setOption(item.id);
                    setIsBtnDisabled(!item.isAllowed);
                  }}
                />
              </>
            )
        )}
      </div>

      <div className=" btns">
        <div className=" btn__big_screen margin-right-20">
          <button
            className="saara_custom_btn saara__btn btn__back back-page"
            onClick={backHandler}
          >
            {storeConfigState?.themeConfig?.back_button_label}
          </button>
        </div>

        <div>
          <Button
            name={storeConfigState?.themeConfig?.continue_button_label}
            onClick={buttonHandler}
            disabled={isBtnDisabled}
          />
        </div>
      </div>
    </div>
  );
};
